import { FC } from "react";
import HistoryTable from "./HistoryTable";
import { IAntTableScroll } from "../ExpandedTable/ExpandedTable";
import { DraggableModal } from "../Modals/DraggableModal/DraggableModal";
import { ModalProps } from "antd";

interface IProps extends ModalProps {
  historyUrl: string;
  ruNames?: {
    [index: string]: string;
  };
  scroll?: IAntTableScroll;
}

const defaultScroll = {
  scrollToFirstRowOnChange: true,
  y: 240,
};

const HistoryModal: FC<IProps> = ({
  historyUrl,
  ruNames,
  scroll = defaultScroll,
  ...otherProps
}) => {
  scroll = {
    ...defaultScroll,
    ...scroll,
  };

  return (
    <DraggableModal footer={null} {...otherProps}>
      <HistoryTable historyUrl={historyUrl} ruNames={ruNames} scroll={scroll} />
    </DraggableModal>
  );
};

export default HistoryModal;
